import { z } from 'zod';

export const Statuses = ['OPERATIONAL', 'TEST', 'EXERCISE'] as const;
export const StatusZod = z.enum(Statuses);
export type Status = z.infer<typeof StatusZod>;

export const StatusText: Record<Status, string> = {
  OPERATIONAL: 'Operational',
  TEST: 'Test',
  EXERCISE: 'Exercise',
};

export const StatusIwxxmText: Record<Status, string> = {
  OPERATIONAL: 'OPERATIONAL',
  TEST: 'TEST',
  EXERCISE: 'EXERCISE',
};

export const StatusTacText: Record<Status, string> = {
  OPERATIONAL: 'OPERATIONAL',
  TEST: 'TEST',
  EXERCISE: 'EXER',
};
